import React from 'react';
import { OrderStatus, PaymentStatus } from '../types';

interface StatusBadgeProps {
  status: OrderStatus | PaymentStatus | string;
  type?: 'order' | 'payment' | 'risk';
}

export const StatusBadge: React.FC<StatusBadgeProps> = ({ status, type = 'order' }) => {
  let colorClass = 'bg-gray-100 text-gray-800';

  if (type === 'order') {
    switch (status) {
      case OrderStatus.CLEARED:
        colorClass = 'bg-emerald-100 text-emerald-700 border border-emerald-200';
        break;
      case OrderStatus.SHIPPED:
        // Updated to emerald color as requested
        colorClass = 'bg-emerald-50 text-emerald-600 border border-emerald-100';
        break;
      case OrderStatus.UNDER_CLEARANCE:
        colorClass = 'bg-indigo-100 text-indigo-700 border border-indigo-200';
        break;
      case OrderStatus.UNDER_PRODUCTION:
      case OrderStatus.PROCESSING: // Added support for PROCESSING state
        colorClass = 'bg-amber-100 text-amber-700 border border-amber-200';
        break;
      case OrderStatus.PLACED: // Added support for PLACED state
        colorClass = 'bg-sky-100 text-sky-700 border border-sky-200';
        break;
      case OrderStatus.CANCELLED:
        colorClass = 'bg-red-100 text-red-700 border border-red-200';
        break;
      default:
        colorClass = 'bg-slate-100 text-slate-700 border border-slate-200';
    }
  } else if (type === 'payment') {
    switch (status) {
      case PaymentStatus.PAID:
        colorClass = 'bg-emerald-100 text-emerald-700 border border-emerald-200';
        break;
      case PaymentStatus.PARTIAL:
        colorClass = 'bg-yellow-100 text-yellow-700 border border-yellow-200';
        break;
      case PaymentStatus.PENDING:
        colorClass = 'bg-rose-100 text-rose-700 border border-rose-200';
        break;
    }
  } else if (type === 'risk') {
     switch (status) {
      case 'LOW':
        colorClass = 'bg-green-50 text-green-600 border border-green-200';
        break;
      case 'MEDIUM':
        colorClass = 'bg-yellow-50 text-yellow-600 border border-yellow-200';
        break;
      case 'HIGH':
        colorClass = 'bg-red-50 text-red-600 border border-red-200';
        break;
    }
  }

  return (
    <span className={`px-2.5 py-0.5 rounded-full text-[10px] font-black uppercase tracking-widest whitespace-nowrap ${colorClass}`}>
      {status}
    </span>
  );
};